import React from "react";
import _ from "lodash";
import {FormControl, FormHelperText} from "@material-ui/core";
import {Controller} from "react-hook-form";
import {KeyboardDatePicker, KeyboardDateTimePicker} from "@material-ui/pickers";
import {formatISO} from "date-fns";

export default function DateView(
  {
    errors = {},
    control,
    name,
    variant,
    fullWidth = true,
    label,
    items = {},
    margin,
    onBlur,
    ...props
  },
) {
  const error = _.get(errors, name);

  return (
    <FormControl
      variant={variant}
      fullWidth={fullWidth}
      margin={margin}
      error={!!error}
      onBlur={onBlur}
    >
      <Controller
        name={name}
        control={control}
        defaultValue=""
        render={({field: {onChange, ...field}}) => (
          <KeyboardDatePicker
            label={label}
            inputProps={{
              id: name,
            }}
            ampm={false}
            format="yyyy-MM-dd"
            cancelLabel="Abbrechen"
            mask="____-__-__"
            onChange={(date, value) => {
              try {
                value = formatISO(date, { representation: 'date' });
              } catch (e) {
                // value = null;
              }
              return onChange(date, value);
            }}
            {...props}
            {...field}
          />
        )}
      />
      {error ? <FormHelperText>{error.message}</FormHelperText> : null}
    </FormControl>
  );
}
